import Masonry from 'masonry-layout';
import Filter from './filter';

const container = document.query('.slx-projects');
const itemSelector = '.slx-projects__item';
let msnry = null;
let filter = null;


function init() {
	initMasonry();
	filter = new Filter({
		el: container
	});
	filter.start();
	filter.events.on('done', () => msnry.layout());
	document.addEventListener('projectsFilterChanged', () => {
		msnry.layout();
	});
}

function initMasonry() {
	msnry = new Masonry(container.query('.slx-projects__section'), {
		itemSelector,
		percentPosition: true,
		columnWidth: '.slx-projects__item--ref',
		transitionDuration: 0
	});
}

if (container) {
	init();
}
